import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router'
import { CurriculoService } from '../curriculo.service'
import { ExibirMenuService } from '../../../shared/exibir-menu.service'
import { AcessoApiService } from '../../../../acessoApi.service'
import { DadosAcessoService } from '../../../../dadosAcesso.service'
import { NotificationsService } from 'angular2-notifications';
import { EmailModel } from './email.model'
import { TelefoneModel } from './telefone.model'
import * as jsPDF from 'jspdf'
declare var $

@Component({
  selector: 'app-edit-curriculo',
  templateUrl: './edit-curriculo.component.html',
  styleUrls: ['./edit-curriculo.component.css']
})
export class EditCurriculoComponent implements OnInit {

  public statusInicial: string = "A"
  public status1: string = 'B'
  public status2: string = 'C'
  public status3: string = 'D'
  public status4: string = 'E'
  public status5: string = 'F'
  public cod_cand: number
  public dadosCand: any
  public analiseCand: string
  public statusSelecionado: string
  public NOME_PESSOA: string
  public VALOR_DCPS: string
  public NASCIMENTO_PESSOA: string
  public SEXO_PESSOA: string
  public ESTADOCIVIL_CAND: string
  public BAIRRO_ENDR: string
  public CIDADE_ENDR: string
  public ESTADO_ENDR: string
  public LOGR_ENDR: string
  public NUMERO_ENDR: string
  public COMPL_ENDR: any
  public CEP_ENDR: string
  public INTERESSE_CAND: string
  public OBS_CAND: string
  public ANALISE_CAND: string
  public PRETENSAO_CAND: number
  public emails: any
  public telefones: any
  public escolaridadesCandidato: any
  public experienciasCandidato: any
  public atividadesExtrasCandidatos: any

  constructor(private notificacao: NotificationsService, private acessoAPI: AcessoApiService, private curriculoService: CurriculoService, private exibirItens: ExibirMenuService, private dadosAcesso: DadosAcessoService, private router: Router) {
    if(sessionStorage.getItem('cod_loja') === null){

      this.router.navigate(["/"])
    }
    this.cod_cand = this.curriculoService.recuperarCodCand()

    this.acessoAPI.ResgatarEdicaoCurriculo(this.cod_cand).subscribe(data => {
      this.dadosCand = data;
      this.NOME_PESSOA = data[0].candidato.PESSOAS.NOME_PESSOA
      this.VALOR_DCPS = data[0].candidato.PESSOAS.DOCUMENTOS_PESSOA[0].VALOR_DCPS
      this.NASCIMENTO_PESSOA = data[0].candidato.PESSOAS.NASCIMENTO_PESSOA
      this.SEXO_PESSOA = data[0].candidato.PESSOAS.SEXO_PESSOA
      if (this.SEXO_PESSOA === "A") {
        this.SEXO_PESSOA = "Masculino"
      } else {
        this.SEXO_PESSOA = "Feminino"
      }
      this.ESTADOCIVIL_CAND = data[0].candidato.ESTADOCIVIL_CAND
      if(this.ESTADOCIVIL_CAND === "A"){
        this.ESTADOCIVIL_CAND = "Solteiro(a)"
      }else if(this.ESTADOCIVIL_CAND === "B"){
        this.ESTADOCIVIL_CAND = "Casado(a)"
        
      }else{
        this.ESTADOCIVIL_CAND = "Divorciado(a)"

      }
      this.BAIRRO_ENDR = data[0].candidato.PESSOAS.ENDERECOS[0].BAIRRO_ENDR
      this.CIDADE_ENDR = data[0].candidato.PESSOAS.ENDERECOS[0].CIDADE_ENDR
      this.ESTADO_ENDR = data[0].candidato.PESSOAS.ENDERECOS[0].ESTADO_ENDR
      this.LOGR_ENDR = data[0].candidato.PESSOAS.ENDERECOS[0].LOGR_ENDR
      this.NUMERO_ENDR = data[0].candidato.PESSOAS.ENDERECOS[0].NUMERO_ENDR
      this.COMPL_ENDR = data[0].candidato.PESSOAS.ENDERECOS[0].COMPL_ENDR
      this.CEP_ENDR = data[0].candidato.PESSOAS.ENDERECOS[0].CEP_ENDR
      this.PRETENSAO_CAND = data[0].candidato.PRETENCAO_CAND
      this.statusSelecionado = data[0].candidato.CURRICULO_CAND
      this.emails = data[0].candidato.PESSOAS.EMAILS
      this.telefones = data[0].candidato.PESSOAS.TELEFONES
      this.OBS_CAND = data[0].candidato.OBS_CAND
      this.INTERESSE_CAND = data[0].candidato.INTERESSE_CAND
      this.ANALISE_CAND = data[0].candidato.ANALISE_CAND
      this.escolaridadesCandidato = data[0].candidato.ESCOLARIDADES_CANDIDATO
      this.experienciasCandidato = data[0].candidato.EXPERIENCIAS_CANDIDATO
      this.atividadesExtrasCandidatos = data[0].candidato.ATIVIDADES_EXTRA_CANDIDATO

    }, error => {

    })

    if (dadosAcesso.recuperarDadosDeAcesso() === false) {
      this.router.navigate(["/"])
    }


  }

  ngOnInit() {

  }

  changeStatus(status) {

    this.statusSelecionado = status.value;
  }

  convert() {
    const elementToPrint = document.getElementById('Curriculo');
    const pdf = new jsPDF('p', 'pt', 'a4');
    pdf.addHTML(elementToPrint, () => {
      pdf.save(this.NOME_PESSOA + '.pdf');
    });
  }

  getAnalise(analise: Event) {
    this.ANALISE_CAND = ((<HTMLInputElement>analise.target).value)
  }

  enviaDados() {
    this.acessoAPI.EnviarReAnalise(this.cod_cand, this.statusSelecionado, this.ANALISE_CAND).subscribe(data => {

      this.notificacao.success(
        'Alteração enviada!',
        "Alterado com sucesso!",
        {
          timeOut: 2000,
          showProgressBar: false,
          pauseOnHover: false,
          clickToClose: false,
          maxLength: 2
        }
      )

    }, error => {
      this.notificacao.error(
        'Erro!',
          error._body,
        {
          timeOut: 2000,
          showProgressBar: false,
          pauseOnHover: false,
          clickToClose: false,
          maxLength: 2
        }
      )
    })
  }

  retornarCurriculo() {
    this.router.navigate(["/administrativo/curriculos"])
  }



}



// WEBPACK FOOTER //
// ./src/app/pages/administracao/curriculo/edit-curriculo/edit-curriculo.component.ts